module.exports = __webpack_public_path__ + "static/media/logo-light.a046c308.svg";